import { render, staticRenderFns } from "./PageMainNav.vue?vue&type=template&id=99e238fe&"
import script from "./PageMainNav.vue?vue&type=script&lang=js&"
export * from "./PageMainNav.vue?vue&type=script&lang=js&"
import style0 from "./PageMainNav.vue?vue&type=style&index=0&id=99e238fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports